export default __webpack_public_path__ + "static/media/verified-48.5e8c1595.svg";